export default __webpack_public_path__ + "static/media/aboutSmallimg.a8c6e9b3.webp";